$(document)
  .on('turbo:load', function() {
    let parent = document.getElementsByClassName('package-pricing-wrapper')
    let child  = document.getElementsByClassName('previous-next-package')

    parent.id  = 'package-pricing-wrapper-id'
    child.id   = 'previous-next-package-id'

    $(parent).append(child)
  })